__turbopack_context__.v({
  "overlay": "SoldOutOverlay-module__qUj-eG__overlay",
  "text": "SoldOutOverlay-module__qUj-eG__text",
});
